import { Loader } from "@googlemaps/js-api-loader";

const loader = new Loader({
  apiKey: "AIzaSyAeBdhFNr9xJLiFXHeFFtcQkc_KMk4wEN4",
  version: "weekly",
  libraries: ["places"],
});

loader
  .load()
  .then((google) => {
    // Cost of Google API calls
    // https://developers.google.com/maps/documentation/javascript/places-autocomplete#advanced-cost-optimization

    // Set options at construction
    // https://developers.google.com/maps/documentation/javascript/places-autocomplete#set-options-at-construction

    $("input.g-autocomplete").each(function () {
      let form = $(this).closest("form");
      let place = undefined;
      let autocomplete = new google.maps.places.Autocomplete(this, {
        componentRestrictions: {
          country: "us",
        },
        fields: ["geometry", "address_components", "formatted_address"],
        strictBounds: false,
      });

      autocomplete.addListener("place_changed", (arg1, arg2) => {
        place = autocomplete.getPlace();
        form.find('input[name="lat"]').val(place.geometry.location.lat());
        form.find('input[name="lng"]').val(place.geometry.location.lng());
        form.find('input[name="address"]').val(place.formatted_address);
        $.each(place.address_components, (index, component) => {
          if ($.inArray("locality", component.types) > -1) {
            form.find('input[name="city"]').val(place.address_components[index].long_name);
          }
          if ($.inArray("administrative_area_level_1", component.types) > -1) {
            form.find('input[name="state"]').val(place.address_components[index].short_name);
          }
        });
      });

      $(this).on("blur", (e) => {
        if (!place) {
          $(this).val("");
          form.find('input[name="lat"]').val("");
          form.find('input[name="lng"]').val("");
          form.find('input[name="address"]').val("");
          form.find('input[name="city"]').val("");
          form.find('input[name="state"]').val("");
        }
      });

      $(this).on("keypress", (e) => {
        if (e.key == "Enter") {
          return false;
        }
        place = undefined;
      });

      form.on("submit", (e) => {
        if ($(this).is(":visible")) {
          // Or address is in the address bar
          const params = Object.fromEntries(new URLSearchParams(location.search));
          return place !== undefined || params.address !== undefined;
        }
      });
    });
  })
  .catch((e) => {
    // do something
  });
